import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Track My Package';
const SITE_URL = 'https://trackmypackage.app';
const DEFAULT_IMAGE = `${SITE_URL}/assets/trackmypackage-logo.png`;

export default function SEOHead({ title, description, path = '/', type = 'website', keywords = '', jsonLd }) {
  const fullTitle = path === '/' ? `${SITE_NAME} — Courier CRM & Universal Package Tracking` : `${title} | ${SITE_NAME}`;
  const canonical = `${SITE_URL}${path}`;
  const desc = description || 'Manage your courier business like a pro. Universal tracking for UPS, FedEx, USPS, DHL & 1200+ carriers. Client portals, invoicing, Stripe & PayPal payments.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={keywords || 'courier CRM, package tracking, shipping management, USPS tracking, UPS tracking, FedEx tracking, DHL tracking, courier software, logistics SaaS, invoice management, client portal'} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />

      <meta name="robots" content="index, follow" />
      <meta name="author" content="Track My Package" />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
